import {
  Component,
  ComponentFactoryResolver,
  Injector,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import { SkyTileDashboardService } from '../tile-dashboard/tile-dashboard.service';

let columnIdIndex = 0;


export class SkyTileDashboardColumnComponent {
  public bagId: string;

  public columnId: string;

  
  public content: ViewContainerRef;

  constructor(
    public resolver: ComponentFactoryResolver,
    public injector: Injector,
    private dashboardService: SkyTileDashboardService
  ) {
    columnIdIndex++;

    this.columnId = 'tile-dashboard-column-' + columnIdIndex;

    this.bagId = this.dashboardService.bagId;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tile-dashboard-column',
  styles: [`:host {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  padding: 0 10px;
}

@media (max-width: 767px) {
  :host {
    padding: 0;
  }
  :host /deep/ .sky-tile {
    margin-bottom: 0 !important;
  }
}

.sky-tile-dashboard-column {
  min-height: 100px;
  width: 100%;
}
`],
  template: `<div class="sky-tile-dashboard-column" [dragula]="bagId">
  <div #content></div>
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
{type: Injector, },
{type: SkyTileDashboardService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'content': [{ type: ViewChild, args: ['content', {read: ViewContainerRef}, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
